import { RelatedActivityType } from "@/shared/domain";

import { getSpApi, pagedRequestConfig } from "./apiRoot";
import { UrlManager } from "./UrlManager";

export type ActivitiesQueryParameters =
    | Paths.ApiActivityContract$Id.Get.QueryParameters
    | Paths.ApiActivityInsuredgood$Id.Get.QueryParameters
    | Paths.ApiActivityPolicyholder$Id.Get.QueryParameters
    | Paths.ApiActivityClaim$Id.Get.QueryParameters;

export const getActivities = async (
    id: number | string,
    featureType: RelatedActivityType,
    params: ActivitiesQueryParameters,
): Promise<MyBrokerApi.ActivityPayload> => {
    const axiosRequestConfig = pagedRequestConfig<ActivitiesQueryParameters>({ params });

    const { data } = await getSpApi().get<MyBrokerApi.ActivityPayload>(
        UrlManager.activities(featureType, id),
        axiosRequestConfig,
    );
    return data;
};
